<template>
  <div
    v-if="errorMessage"
    class="flex h-full flex-col items-center justify-center"
  >
    <BaseCard
      class="flex size-full flex-col items-center justify-center p-8 sm:h-auto sm:max-w-md"
    >
      <IconExclamationTriangle
        class="mx-auto mb-4 size-16 text-primary"
      />
      <h1
        class="mb-2 text-2xl font-semibold text-background-fg/87"
      >
        {{ errorMessage }}
      </h1>

      <p class="mb-6 text-center text-background-fg/60">
        Please try your access link again, or request a new
        link via the login page.
      </p>
    </BaseCard>
  </div>
</template>

<script setup lang="ts">
const token = useRouteQuery<string>("token")
const { navigateToHome } = useNavigateToHome()

const errorMessage = ref<string | null>(null)

onMounted(async () => {
  if (!token.value) {
    errorMessage.value = "No token provided"
    return
  }

  try {
    await handleLogInLink({
      token: token.value,
    })

    navigateToHome()
  } catch {
    errorMessage.value = "Oops! Something went wrong."
  }
})
</script>
